var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"sponsor-banner",class:{ fullwidth: _vm.fullwidth },attrs:{"href":_vm.sponsorLink,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.sponsorProcessedURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }